/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetAlarmNotificationsByTreatmentResponse } from '../model';
// @ts-ignore
import { GetTreamentDataLogResponse } from '../model';
// @ts-ignore
import { GetTreamentGraphResponse } from '../model';
// @ts-ignore
import { GetTreamentMonitoringDetailResponse } from '../model';
// @ts-ignore
import { GetTreamentProceedTimeResponse } from '../model';
// @ts-ignore
import { GetTreamentRequestsResponse } from '../model';
// @ts-ignore
import { GetTreamentsMonitoringResponse } from '../model';
// @ts-ignore
import { GetVariableDataByTabNameResponse } from '../model';
// @ts-ignore
import { PostGreenButtonActionRequest } from '../model';
// @ts-ignore
import { PostGreenButtonActionResponse } from '../model';
// @ts-ignore
import { PostRedButtonActionRequest } from '../model';
// @ts-ignore
import { PostRedButtonActionResponse } from '../model';
// @ts-ignore
import { PostSubmitVariableDataRequest } from '../model';
// @ts-ignore
import { PostSubmitVariableDataResponse } from '../model';
// @ts-ignore
import { PostTreatmentBoxSetting } from '../model';
// @ts-ignore
import { PostTreatmentBoxSettingResponse } from '../model';
/**
 * TreatmentMonitoringApi - axios parameter creator
 * @export
 */
export const TreatmentMonitoringApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PostGreenButtonActionRequest} postGreenButtonActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doGreenButtonAction: async (postGreenButtonActionRequest: PostGreenButtonActionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postGreenButtonActionRequest' is not null or undefined
            assertParamExists('doGreenButtonAction', 'postGreenButtonActionRequest', postGreenButtonActionRequest)
            const localVarPath = `/api/treatment-monitoring/green-button/action`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postGreenButtonActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostRedButtonActionRequest} postRedButtonActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doRedButtonAction: async (postRedButtonActionRequest: PostRedButtonActionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postRedButtonActionRequest' is not null or undefined
            assertParamExists('doRedButtonAction', 'postRedButtonActionRequest', postRedButtonActionRequest)
            const localVarPath = `/api/treatment-monitoring/red-button/action`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postRedButtonActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} language 
         * @param {string} unitId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} [treatmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlarmNotificationsByTreatment: async (language: string, unitId: string, startDate: string, endDate: string, limit: number, page: number, treatmentId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getAlarmNotificationsByTreatment', 'language', language)
            // verify required parameter 'unitId' is not null or undefined
            assertParamExists('getAlarmNotificationsByTreatment', 'unitId', unitId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getAlarmNotificationsByTreatment', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getAlarmNotificationsByTreatment', 'endDate', endDate)
            // // verify required parameter 'limit' is not null or undefined
            // assertParamExists('getAlarmNotificationsByTreatment', 'limit', limit)
            // // verify required parameter 'page' is not null or undefined
            // assertParamExists('getAlarmNotificationsByTreatment', 'page', page)
            const localVarPath = `/api/treatment-monitoring/alarms/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (treatmentId !== undefined) {
                localVarQueryParameter['treatmentId'] = treatmentId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} unitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoxSetting: async (unitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unitId' is not null or undefined
            assertParamExists('getBoxSetting', 'unitId', unitId)
            const localVarPath = `/api/treatment-monitoring/boxSetting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} variableIds 
         * @param {string} treatmentId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentDataLog: async (variableIds: string, treatmentId: string, startDate: string, endDate: string, limit: number, page: number, orderBy: string, orderDesc: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'variableIds' is not null or undefined
            assertParamExists('getTreatmentDataLog', 'variableIds', variableIds)
            // verify required parameter 'treatmentId' is not null or undefined
            assertParamExists('getTreatmentDataLog', 'treatmentId', treatmentId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getTreatmentDataLog', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getTreatmentDataLog', 'endDate', endDate)
            // // verify required parameter 'limit' is not null or undefined
            // assertParamExists('getTreatmentDataLog', 'limit', limit)
            // // verify required parameter 'page' is not null or undefined
            // assertParamExists('getTreatmentDataLog', 'page', page)
            // verify required parameter 'orderBy' is not null or undefined
            assertParamExists('getTreatmentDataLog', 'orderBy', orderBy)
            // verify required parameter 'orderDesc' is not null or undefined
            assertParamExists('getTreatmentDataLog', 'orderDesc', orderDesc)
            const localVarPath = `/api/treatment-monitoring/detail/treatmentDataLog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (variableIds !== undefined) {
                localVarQueryParameter['variableIds'] = variableIds;
            }

            if (treatmentId !== undefined) {
                localVarQueryParameter['treatmentId'] = treatmentId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDesc !== undefined) {
                localVarQueryParameter['orderDesc'] = orderDesc;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} unitId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} treatmentId 
         * @param {string} variableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentGraph: async (unitId: string, startDate: string, endDate: string, treatmentId: string, variableId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unitId' is not null or undefined
            assertParamExists('getTreatmentGraph', 'unitId', unitId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getTreatmentGraph', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getTreatmentGraph', 'endDate', endDate)
            // verify required parameter 'treatmentId' is not null or undefined
            assertParamExists('getTreatmentGraph', 'treatmentId', treatmentId)
            // verify required parameter 'variableId' is not null or undefined
            assertParamExists('getTreatmentGraph', 'variableId', variableId)
            const localVarPath = `/api/treatment-monitoring/graph`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (treatmentId !== undefined) {
                localVarQueryParameter['treatmentId'] = treatmentId;
            }

            if (variableId !== undefined) {
                localVarQueryParameter['variableId'] = variableId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationIdList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentMonitoring: async (locationIdList: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationIdList' is not null or undefined
            assertParamExists('getTreatmentMonitoring', 'locationIdList', locationIdList)
            const localVarPath = `/api/treatment-monitoring`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationIdList !== undefined) {
                localVarQueryParameter['locationIdList'] = locationIdList;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} unitId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} treatmentId 
         * @param {string} variableIdList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentMonitoringDetail: async (unitId: string, startDate: string, endDate: string, treatmentId: string, variableIdList: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unitId' is not null or undefined
            assertParamExists('getTreatmentMonitoringDetail', 'unitId', unitId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getTreatmentMonitoringDetail', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getTreatmentMonitoringDetail', 'endDate', endDate)
            // verify required parameter 'treatmentId' is not null or undefined
            assertParamExists('getTreatmentMonitoringDetail', 'treatmentId', treatmentId)
            // verify required parameter 'variableIdList' is not null or undefined
            assertParamExists('getTreatmentMonitoringDetail', 'variableIdList', variableIdList)
            const localVarPath = `/api/treatment-monitoring/detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (treatmentId !== undefined) {
                localVarQueryParameter['treatmentId'] = treatmentId;
            }

            if (variableIdList !== undefined) {
                localVarQueryParameter['variableIdList'] = variableIdList;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} variableId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {string} [treatmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentProceedTime: async (variableId: string, startDate: string, endDate: string, limit: number, page: number, orderBy: string, orderDesc: string, treatmentId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'variableId' is not null or undefined
            assertParamExists('getTreatmentProceedTime', 'variableId', variableId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getTreatmentProceedTime', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getTreatmentProceedTime', 'endDate', endDate)
            // verify required parameter 'limit' is not null or undefined
            // assertParamExists('getTreatmentProceedTime', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getTreatmentProceedTime', 'page', page)
            // verify required parameter 'orderBy' is not null or undefined
            assertParamExists('getTreatmentProceedTime', 'orderBy', orderBy)
            // verify required parameter 'orderDesc' is not null or undefined
            assertParamExists('getTreatmentProceedTime', 'orderDesc', orderDesc)
            const localVarPath = `/api/treatment-monitoring/detail/treatmentProceedTime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (variableId !== undefined) {
                localVarQueryParameter['variableId'] = variableId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (treatmentId !== undefined) {
                localVarQueryParameter['treatmentId'] = treatmentId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDesc !== undefined) {
                localVarQueryParameter['orderDesc'] = orderDesc;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} unitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentRunningByUnit: async (unitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unitId' is not null or undefined
            assertParamExists('getTreatmentRunningByUnit', 'unitId', unitId)
            const localVarPath = `/api/treatment-monitoring/detail/treatmentList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} unitId 
         * @param {string} tabName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariableDatasByUnitIdTabName: async (unitId: string, tabName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unitId' is not null or undefined
            assertParamExists('getVariableDatasByUnitIdTabName', 'unitId', unitId)
            // verify required parameter 'tabName' is not null or undefined
            assertParamExists('getVariableDatasByUnitIdTabName', 'tabName', tabName)
            const localVarPath = `/api/treatment-monitoring/variable-datas/get-tab`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }

            if (tabName !== undefined) {
                localVarQueryParameter['tab-name'] = tabName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostTreatmentBoxSetting} postTreatmentBoxSetting 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBoxSetting: async (postTreatmentBoxSetting: PostTreatmentBoxSetting, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postTreatmentBoxSetting' is not null or undefined
            assertParamExists('saveBoxSetting', 'postTreatmentBoxSetting', postTreatmentBoxSetting)
            const localVarPath = `/api/treatment-monitoring/boxSetting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postTreatmentBoxSetting, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostSubmitVariableDataRequest} postSubmitVariableDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitVariableData: async (postSubmitVariableDataRequest: PostSubmitVariableDataRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postSubmitVariableDataRequest' is not null or undefined
            assertParamExists('submitVariableData', 'postSubmitVariableDataRequest', postSubmitVariableDataRequest)
            const localVarPath = `/api/treatment-monitoring/variable-datas/submit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postSubmitVariableDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TreatmentMonitoringApi - functional programming interface
 * @export
 */
export const TreatmentMonitoringApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TreatmentMonitoringApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PostGreenButtonActionRequest} postGreenButtonActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doGreenButtonAction(postGreenButtonActionRequest: PostGreenButtonActionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostGreenButtonActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doGreenButtonAction(postGreenButtonActionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostRedButtonActionRequest} postRedButtonActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doRedButtonAction(postRedButtonActionRequest: PostRedButtonActionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostRedButtonActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doRedButtonAction(postRedButtonActionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} language 
         * @param {string} unitId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} [treatmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlarmNotificationsByTreatment(language: string, unitId: string, startDate: string, endDate: string, limit: number, page: number, treatmentId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAlarmNotificationsByTreatmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlarmNotificationsByTreatment(language, unitId, startDate, endDate, limit, page, treatmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} unitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBoxSetting(unitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostTreatmentBoxSettingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBoxSetting(unitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} variableIds 
         * @param {string} treatmentId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatmentDataLog(variableIds: string, treatmentId: string, startDate: string, endDate: string, limit: number, page: number, orderBy: string, orderDesc: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreamentDataLogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatmentDataLog(variableIds, treatmentId, startDate, endDate, limit, page, orderBy, orderDesc, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} unitId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} treatmentId 
         * @param {string} variableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatmentGraph(unitId: string, startDate: string, endDate: string, treatmentId: string, variableId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreamentGraphResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatmentGraph(unitId, startDate, endDate, treatmentId, variableId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationIdList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatmentMonitoring(locationIdList: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreamentsMonitoringResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatmentMonitoring(locationIdList, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} unitId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} treatmentId 
         * @param {string} variableIdList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatmentMonitoringDetail(unitId: string, startDate: string, endDate: string, treatmentId: string, variableIdList: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreamentMonitoringDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatmentMonitoringDetail(unitId, startDate, endDate, treatmentId, variableIdList, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} variableId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {string} [treatmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatmentProceedTime(variableId: string, startDate: string, endDate: string, limit: number, page: number, orderBy: string, orderDesc: string, treatmentId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreamentProceedTimeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatmentProceedTime(variableId, startDate, endDate, limit, page, orderBy, orderDesc, treatmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} unitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatmentRunningByUnit(unitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreamentRequestsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatmentRunningByUnit(unitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} unitId 
         * @param {string} tabName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVariableDatasByUnitIdTabName(unitId: string, tabName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVariableDataByTabNameResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVariableDatasByUnitIdTabName(unitId, tabName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostTreatmentBoxSetting} postTreatmentBoxSetting 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveBoxSetting(postTreatmentBoxSetting: PostTreatmentBoxSetting, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostTreatmentBoxSettingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveBoxSetting(postTreatmentBoxSetting, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostSubmitVariableDataRequest} postSubmitVariableDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitVariableData(postSubmitVariableDataRequest: PostSubmitVariableDataRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostSubmitVariableDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitVariableData(postSubmitVariableDataRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TreatmentMonitoringApi - factory interface
 * @export
 */
export const TreatmentMonitoringApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TreatmentMonitoringApiFp(configuration)
    return {
        /**
         * 
         * @param {PostGreenButtonActionRequest} postGreenButtonActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doGreenButtonAction(postGreenButtonActionRequest: PostGreenButtonActionRequest, options?: any): AxiosPromise<PostGreenButtonActionResponse> {
            return localVarFp.doGreenButtonAction(postGreenButtonActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostRedButtonActionRequest} postRedButtonActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doRedButtonAction(postRedButtonActionRequest: PostRedButtonActionRequest, options?: any): AxiosPromise<PostRedButtonActionResponse> {
            return localVarFp.doRedButtonAction(postRedButtonActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} language 
         * @param {string} unitId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} [treatmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlarmNotificationsByTreatment(language: string, unitId: string, startDate: string, endDate: string, limit: number, page: number, treatmentId?: string, options?: any): AxiosPromise<GetAlarmNotificationsByTreatmentResponse> {
            return localVarFp.getAlarmNotificationsByTreatment(language, unitId, startDate, endDate, limit, page, treatmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} unitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoxSetting(unitId: string, options?: any): AxiosPromise<PostTreatmentBoxSettingResponse> {
            return localVarFp.getBoxSetting(unitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} variableIds 
         * @param {string} treatmentId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentDataLog(variableIds: string, treatmentId: string, startDate: string, endDate: string, limit: number, page: number, orderBy: string, orderDesc: string, options?: any): AxiosPromise<GetTreamentDataLogResponse> {
            return localVarFp.getTreatmentDataLog(variableIds, treatmentId, startDate, endDate, limit, page, orderBy, orderDesc, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} unitId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} treatmentId 
         * @param {string} variableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentGraph(unitId: string, startDate: string, endDate: string, treatmentId: string, variableId: string, options?: any): AxiosPromise<GetTreamentGraphResponse> {
            return localVarFp.getTreatmentGraph(unitId, startDate, endDate, treatmentId, variableId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationIdList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentMonitoring(locationIdList: string, options?: any): AxiosPromise<GetTreamentsMonitoringResponse> {
            return localVarFp.getTreatmentMonitoring(locationIdList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} unitId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} treatmentId 
         * @param {string} variableIdList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentMonitoringDetail(unitId: string, startDate: string, endDate: string, treatmentId: string, variableIdList: string, options?: any): AxiosPromise<GetTreamentMonitoringDetailResponse> {
            return localVarFp.getTreatmentMonitoringDetail(unitId, startDate, endDate, treatmentId, variableIdList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} variableId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {string} [treatmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentProceedTime(variableId: string, startDate: string, endDate: string, limit: number, page: number, orderBy: string, orderDesc: string, treatmentId?: string, options?: any): AxiosPromise<GetTreamentProceedTimeResponse> {
            return localVarFp.getTreatmentProceedTime(variableId, startDate, endDate, limit, page, orderBy, orderDesc, treatmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} unitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentRunningByUnit(unitId: string, options?: any): AxiosPromise<GetTreamentRequestsResponse> {
            return localVarFp.getTreatmentRunningByUnit(unitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} unitId 
         * @param {string} tabName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariableDatasByUnitIdTabName(unitId: string, tabName: string, options?: any): AxiosPromise<GetVariableDataByTabNameResponse> {
            return localVarFp.getVariableDatasByUnitIdTabName(unitId, tabName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostTreatmentBoxSetting} postTreatmentBoxSetting 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBoxSetting(postTreatmentBoxSetting: PostTreatmentBoxSetting, options?: any): AxiosPromise<PostTreatmentBoxSettingResponse> {
            return localVarFp.saveBoxSetting(postTreatmentBoxSetting, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostSubmitVariableDataRequest} postSubmitVariableDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitVariableData(postSubmitVariableDataRequest: PostSubmitVariableDataRequest, options?: any): AxiosPromise<PostSubmitVariableDataResponse> {
            return localVarFp.submitVariableData(postSubmitVariableDataRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for doGreenButtonAction operation in TreatmentMonitoringApi.
 * @export
 * @interface TreatmentMonitoringApiDoGreenButtonActionRequest
 */
export interface TreatmentMonitoringApiDoGreenButtonActionRequest {
    /**
     * 
     * @type {PostGreenButtonActionRequest}
     * @memberof TreatmentMonitoringApiDoGreenButtonAction
     */
    readonly postGreenButtonActionRequest: PostGreenButtonActionRequest
}

/**
 * Request parameters for doRedButtonAction operation in TreatmentMonitoringApi.
 * @export
 * @interface TreatmentMonitoringApiDoRedButtonActionRequest
 */
export interface TreatmentMonitoringApiDoRedButtonActionRequest {
    /**
     * 
     * @type {PostRedButtonActionRequest}
     * @memberof TreatmentMonitoringApiDoRedButtonAction
     */
    readonly postRedButtonActionRequest: PostRedButtonActionRequest
}

/**
 * Request parameters for getAlarmNotificationsByTreatment operation in TreatmentMonitoringApi.
 * @export
 * @interface TreatmentMonitoringApiGetAlarmNotificationsByTreatmentRequest
 */
export interface TreatmentMonitoringApiGetAlarmNotificationsByTreatmentRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetAlarmNotificationsByTreatment
     */
    readonly language: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetAlarmNotificationsByTreatment
     */
    readonly unitId: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetAlarmNotificationsByTreatment
     */
    readonly startDate: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetAlarmNotificationsByTreatment
     */
    readonly endDate: string

    /**
     * 
     * @type {number}
     * @memberof TreatmentMonitoringApiGetAlarmNotificationsByTreatment
     */
    readonly limit: number

    /**
     * 
     * @type {number}
     * @memberof TreatmentMonitoringApiGetAlarmNotificationsByTreatment
     */
    readonly page: number

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetAlarmNotificationsByTreatment
     */
    readonly treatmentId?: string
}

/**
 * Request parameters for getBoxSetting operation in TreatmentMonitoringApi.
 * @export
 * @interface TreatmentMonitoringApiGetBoxSettingRequest
 */
export interface TreatmentMonitoringApiGetBoxSettingRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetBoxSetting
     */
    readonly unitId: string
}

/**
 * Request parameters for getTreatmentDataLog operation in TreatmentMonitoringApi.
 * @export
 * @interface TreatmentMonitoringApiGetTreatmentDataLogRequest
 */
export interface TreatmentMonitoringApiGetTreatmentDataLogRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentDataLog
     */
    readonly variableIds: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentDataLog
     */
    readonly treatmentId: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentDataLog
     */
    readonly startDate: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentDataLog
     */
    readonly endDate: string

    /**
     * 
     * @type {number}
     * @memberof TreatmentMonitoringApiGetTreatmentDataLog
     */
    readonly limit: number

    /**
     * 
     * @type {number}
     * @memberof TreatmentMonitoringApiGetTreatmentDataLog
     */
    readonly page: number

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentDataLog
     */
    readonly orderBy: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentDataLog
     */
    readonly orderDesc: string
}

/**
 * Request parameters for getTreatmentGraph operation in TreatmentMonitoringApi.
 * @export
 * @interface TreatmentMonitoringApiGetTreatmentGraphRequest
 */
export interface TreatmentMonitoringApiGetTreatmentGraphRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentGraph
     */
    readonly unitId: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentGraph
     */
    readonly startDate: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentGraph
     */
    readonly endDate: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentGraph
     */
    readonly treatmentId: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentGraph
     */
    readonly variableId: string
}

/**
 * Request parameters for getTreatmentMonitoring operation in TreatmentMonitoringApi.
 * @export
 * @interface TreatmentMonitoringApiGetTreatmentMonitoringRequest
 */
export interface TreatmentMonitoringApiGetTreatmentMonitoringRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentMonitoring
     */
    readonly locationIdList: string
}

/**
 * Request parameters for getTreatmentMonitoringDetail operation in TreatmentMonitoringApi.
 * @export
 * @interface TreatmentMonitoringApiGetTreatmentMonitoringDetailRequest
 */
export interface TreatmentMonitoringApiGetTreatmentMonitoringDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentMonitoringDetail
     */
    readonly unitId: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentMonitoringDetail
     */
    readonly startDate: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentMonitoringDetail
     */
    readonly endDate: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentMonitoringDetail
     */
    readonly treatmentId: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentMonitoringDetail
     */
    readonly variableIdList: string
}

/**
 * Request parameters for getTreatmentProceedTime operation in TreatmentMonitoringApi.
 * @export
 * @interface TreatmentMonitoringApiGetTreatmentProceedTimeRequest
 */
export interface TreatmentMonitoringApiGetTreatmentProceedTimeRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentProceedTime
     */
    readonly variableId: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentProceedTime
     */
    readonly startDate: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentProceedTime
     */
    readonly endDate: string

    /**
     * 
     * @type {number}
     * @memberof TreatmentMonitoringApiGetTreatmentProceedTime
     */
    readonly limit: number

    /**
     * 
     * @type {number}
     * @memberof TreatmentMonitoringApiGetTreatmentProceedTime
     */
    readonly page: number

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentProceedTime
     */
    readonly orderBy: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentProceedTime
     */
    readonly orderDesc: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentProceedTime
     */
    readonly treatmentId?: string
}

/**
 * Request parameters for getTreatmentRunningByUnit operation in TreatmentMonitoringApi.
 * @export
 * @interface TreatmentMonitoringApiGetTreatmentRunningByUnitRequest
 */
export interface TreatmentMonitoringApiGetTreatmentRunningByUnitRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetTreatmentRunningByUnit
     */
    readonly unitId: string
}

/**
 * Request parameters for getVariableDatasByUnitIdTabName operation in TreatmentMonitoringApi.
 * @export
 * @interface TreatmentMonitoringApiGetVariableDatasByUnitIdTabNameRequest
 */
export interface TreatmentMonitoringApiGetVariableDatasByUnitIdTabNameRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetVariableDatasByUnitIdTabName
     */
    readonly unitId: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentMonitoringApiGetVariableDatasByUnitIdTabName
     */
    readonly tabName: string
}

/**
 * Request parameters for saveBoxSetting operation in TreatmentMonitoringApi.
 * @export
 * @interface TreatmentMonitoringApiSaveBoxSettingRequest
 */
export interface TreatmentMonitoringApiSaveBoxSettingRequest {
    /**
     * 
     * @type {PostTreatmentBoxSetting}
     * @memberof TreatmentMonitoringApiSaveBoxSetting
     */
    readonly postTreatmentBoxSetting: PostTreatmentBoxSetting
}

/**
 * Request parameters for submitVariableData operation in TreatmentMonitoringApi.
 * @export
 * @interface TreatmentMonitoringApiSubmitVariableDataRequest
 */
export interface TreatmentMonitoringApiSubmitVariableDataRequest {
    /**
     * 
     * @type {PostSubmitVariableDataRequest}
     * @memberof TreatmentMonitoringApiSubmitVariableData
     */
    readonly postSubmitVariableDataRequest: PostSubmitVariableDataRequest
}

/**
 * TreatmentMonitoringApi - object-oriented interface
 * @export
 * @class TreatmentMonitoringApi
 * @extends {BaseAPI}
 */
export class TreatmentMonitoringApi extends BaseAPI {
    /**
     * 
     * @param {TreatmentMonitoringApiDoGreenButtonActionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMonitoringApi
     */
    public doGreenButtonAction(requestParameters: TreatmentMonitoringApiDoGreenButtonActionRequest, options?: AxiosRequestConfig) {
        return TreatmentMonitoringApiFp(this.configuration).doGreenButtonAction(requestParameters.postGreenButtonActionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentMonitoringApiDoRedButtonActionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMonitoringApi
     */
    public doRedButtonAction(requestParameters: TreatmentMonitoringApiDoRedButtonActionRequest, options?: AxiosRequestConfig) {
        return TreatmentMonitoringApiFp(this.configuration).doRedButtonAction(requestParameters.postRedButtonActionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentMonitoringApiGetAlarmNotificationsByTreatmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMonitoringApi
     */
    public getAlarmNotificationsByTreatment(requestParameters: TreatmentMonitoringApiGetAlarmNotificationsByTreatmentRequest, options?: AxiosRequestConfig) {
        return TreatmentMonitoringApiFp(this.configuration).getAlarmNotificationsByTreatment(requestParameters.language, requestParameters.unitId, requestParameters.startDate, requestParameters.endDate, requestParameters.limit, requestParameters.page, requestParameters.treatmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentMonitoringApiGetBoxSettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMonitoringApi
     */
    public getBoxSetting(requestParameters: TreatmentMonitoringApiGetBoxSettingRequest, options?: AxiosRequestConfig) {
        return TreatmentMonitoringApiFp(this.configuration).getBoxSetting(requestParameters.unitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentMonitoringApiGetTreatmentDataLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMonitoringApi
     */
    public getTreatmentDataLog(requestParameters: TreatmentMonitoringApiGetTreatmentDataLogRequest, options?: AxiosRequestConfig) {
        return TreatmentMonitoringApiFp(this.configuration).getTreatmentDataLog(requestParameters.variableIds, requestParameters.treatmentId, requestParameters.startDate, requestParameters.endDate, requestParameters.limit, requestParameters.page, requestParameters.orderBy, requestParameters.orderDesc, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentMonitoringApiGetTreatmentGraphRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMonitoringApi
     */
    public getTreatmentGraph(requestParameters: TreatmentMonitoringApiGetTreatmentGraphRequest, options?: AxiosRequestConfig) {
        return TreatmentMonitoringApiFp(this.configuration).getTreatmentGraph(requestParameters.unitId, requestParameters.startDate, requestParameters.endDate, requestParameters.treatmentId, requestParameters.variableId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentMonitoringApiGetTreatmentMonitoringRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMonitoringApi
     */
    public getTreatmentMonitoring(requestParameters: TreatmentMonitoringApiGetTreatmentMonitoringRequest, options?: AxiosRequestConfig) {
        return TreatmentMonitoringApiFp(this.configuration).getTreatmentMonitoring(requestParameters.locationIdList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentMonitoringApiGetTreatmentMonitoringDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMonitoringApi
     */
    public getTreatmentMonitoringDetail(requestParameters: TreatmentMonitoringApiGetTreatmentMonitoringDetailRequest, options?: AxiosRequestConfig) {
        return TreatmentMonitoringApiFp(this.configuration).getTreatmentMonitoringDetail(requestParameters.unitId, requestParameters.startDate, requestParameters.endDate, requestParameters.treatmentId, requestParameters.variableIdList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentMonitoringApiGetTreatmentProceedTimeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMonitoringApi
     */
    public getTreatmentProceedTime(requestParameters: TreatmentMonitoringApiGetTreatmentProceedTimeRequest, options?: AxiosRequestConfig) {
        return TreatmentMonitoringApiFp(this.configuration).getTreatmentProceedTime(requestParameters.variableId, requestParameters.startDate, requestParameters.endDate, requestParameters.limit, requestParameters.page, requestParameters.orderBy, requestParameters.orderDesc, requestParameters.treatmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentMonitoringApiGetTreatmentRunningByUnitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMonitoringApi
     */
    public getTreatmentRunningByUnit(requestParameters: TreatmentMonitoringApiGetTreatmentRunningByUnitRequest, options?: AxiosRequestConfig) {
        return TreatmentMonitoringApiFp(this.configuration).getTreatmentRunningByUnit(requestParameters.unitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentMonitoringApiGetVariableDatasByUnitIdTabNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMonitoringApi
     */
    public getVariableDatasByUnitIdTabName(requestParameters: TreatmentMonitoringApiGetVariableDatasByUnitIdTabNameRequest, options?: AxiosRequestConfig) {
        return TreatmentMonitoringApiFp(this.configuration).getVariableDatasByUnitIdTabName(requestParameters.unitId, requestParameters.tabName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentMonitoringApiSaveBoxSettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMonitoringApi
     */
    public saveBoxSetting(requestParameters: TreatmentMonitoringApiSaveBoxSettingRequest, options?: AxiosRequestConfig) {
        return TreatmentMonitoringApiFp(this.configuration).saveBoxSetting(requestParameters.postTreatmentBoxSetting, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentMonitoringApiSubmitVariableDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentMonitoringApi
     */
    public submitVariableData(requestParameters: TreatmentMonitoringApiSubmitVariableDataRequest, options?: AxiosRequestConfig) {
        return TreatmentMonitoringApiFp(this.configuration).submitVariableData(requestParameters.postSubmitVariableDataRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
